/* @flow */
import styled from 'styled-components'
import THEME from './Spotify1.theme'
import {
  styleProvider,
  getBackgroundStyles,
  getTextStyleByAlignment
} from '@website/common/utils'
import WMContainer from '@website/common/components/WMContainer'
import Container from '@website/common/components/Container'

const getStyleForProp = styleProvider(THEME)

const WmCustomContainer = styled(WMContainer)`
  padding-top: 0;
  > :first-child {
    margin-top: 0;
  }
`

const StyledContainer = styled(Container)`
  ${getBackgroundStyles(THEME)};
  flex-direction: column;
  align-items: center;
  padding: ${({ isEditing }) => (isEditing ? '100px 0 80px 0' : '80px 0')};
  @media only screen and (max-width: 1300px) {
    padding: ${({ isEditing }) => (isEditing ? '140px 0 80px 0' : '80px 0')};
  }
  @media only screen and (max-width: 457px) {
    padding: ${({ isEditing }) => (isEditing ? '120px 0 60px 0' : '60px 0')};
  }
`

const TextContent = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
  > :last-child {
    margin-bottom: 0;
  }
  & > .control-container {
    margin-bottom: 30px;
    h1 {
      margin-bottom: 0;
    }
  }
  @media only screen and (max-width: 1024px) {
    max-width: 100%;
  }
`

const Title = styled.h1`
  color: ${getStyleForProp('heading')};
  margin-bottom: 20px;
  ${getTextStyleByAlignment};
`

const Paragraph = styled.p`
  color: ${getStyleForProp('heading')};
  ${getTextStyleByAlignment};
`

const ControlContainer = styled.div`
  margin: 10px 0 0 0;
`

const MusicWrapper = styled.div`
  width: 100%;
  max-width: 600px;
  font-size: 0;
  margin: 50px auto 0 auto;
  @media only screen and (max-width: 1024px) {
    margin-top: 40px;
  }
`

const MusicContent = styled.div`
  border-radius: ${getStyleForProp('badgeRadius')};
  position: relative;
  width: 100%;
`

const IframeWrapper = styled.div`
  width: 100%;
  position: relative;
  iframe {
    width: 100%;
    height: 80px;
    border-radius: ${getStyleForProp('badgeRadius')};
    -webkit-mask-image: -webkit-radial-gradient(white, black);
  }
`

export default {
  WmCustomContainer,
  ControlContainer,
  StyledContainer,
  TextContent,
  Title,
  Paragraph,
  MusicContent,
  IframeWrapper,
  MusicWrapper
}
